/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  CreateSearchAlertResponse,
  CreateSearchAlertV4Request,
  DeleteSearchAlertPublicParams,
  EditSearchAlertRequest,
  FindAllSearchAlertsParams,
  FindAllSearchAlertsResponse,
  GetSearchAlertForDisplayLegacyParams,
  GetSearchAlertForDisplayParams,
  SearchAlertDisplayResponse,
} from '../../models';
import { customInstance } from '../../custom-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Edit a search alert
 */
export const editSearchAlert = (
  searchAlertId: string,
  editSearchAlertRequest: EditSearchAlertRequest,
  options?: SecondParameter<typeof customInstance<void>>,
) => {
  return customInstance<void>(
    {
      url: `/api/v4/searchalert/alert/${searchAlertId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: editSearchAlertRequest,
    },
    options,
  );
};
/**
 * @summary Delete a search alert
 */
export const deleteSearchAlert = (searchAlertId: string, options?: SecondParameter<typeof customInstance<void>>) => {
  return customInstance<void>({ url: `/api/v4/searchalert/alert/${searchAlertId}`, method: 'DELETE' }, options);
};
/**
 * @summary Find all search alerts of an Account
 */
export const findAllSearchAlerts = (
  params?: FindAllSearchAlertsParams,
  options?: SecondParameter<typeof customInstance<FindAllSearchAlertsResponse>>,
) => {
  return customInstance<FindAllSearchAlertsResponse>({ url: `/api/v4/searchalert/alert`, method: 'GET', params }, options);
};
/**
 * @summary Create a search alert
 */
export const createSearchAlert = (
  createSearchAlertV4Request: CreateSearchAlertV4Request,
  options?: SecondParameter<typeof customInstance<CreateSearchAlertResponse>>,
) => {
  return customInstance<CreateSearchAlertResponse>(
    { url: `/api/v4/searchalert/alert`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: createSearchAlertV4Request },
    options,
  );
};
/**
 * @summary Delete all search alerts of an Account
 */
export const deleteAllSearchAlerts = (options?: SecondParameter<typeof customInstance<void>>) => {
  return customInstance<void>({ url: `/api/v4/searchalert/alert`, method: 'DELETE' }, options);
};
/**
 * @summary Get search alert information and optionally prolong it (public endpoint)
 */
export const getSearchAlertForDisplay = (
  searchAlertId: string,
  params: GetSearchAlertForDisplayParams,
  options?: SecondParameter<typeof customInstance<SearchAlertDisplayResponse>>,
) => {
  return customInstance<SearchAlertDisplayResponse>(
    { url: `/api/v4/public/searchalert/alert/${searchAlertId}`, method: 'POST', params },
    options,
  );
};
/**
 * @deprecated
 * @summary Get search alert information (legacy public endpoint)
 */
export const getSearchAlertForDisplayLegacy = (
  searchAlertId: string,
  params: GetSearchAlertForDisplayLegacyParams,
  options?: SecondParameter<typeof customInstance<SearchAlertDisplayResponse>>,
) => {
  return customInstance<SearchAlertDisplayResponse>(
    { url: `/api/v4/searchalert/unauth/alert/${searchAlertId}`, method: 'GET', params },
    options,
  );
};
/**
 * @summary Delete a search alert (public endpoint)
 */
export const deleteSearchAlertPublic = (
  searchAlertId: string,
  params: DeleteSearchAlertPublicParams,
  options?: SecondParameter<typeof customInstance<void>>,
) => {
  return customInstance<void>({ url: `/api/v4/searchalert/unauth/alert/${searchAlertId}`, method: 'DELETE', params }, options);
};
export type EditSearchAlertResult = NonNullable<Awaited<ReturnType<typeof editSearchAlert>>>;
export type DeleteSearchAlertResult = NonNullable<Awaited<ReturnType<typeof deleteSearchAlert>>>;
export type FindAllSearchAlertsResult = NonNullable<Awaited<ReturnType<typeof findAllSearchAlerts>>>;
export type CreateSearchAlertResult = NonNullable<Awaited<ReturnType<typeof createSearchAlert>>>;
export type DeleteAllSearchAlertsResult = NonNullable<Awaited<ReturnType<typeof deleteAllSearchAlerts>>>;
export type GetSearchAlertForDisplayResult = NonNullable<Awaited<ReturnType<typeof getSearchAlertForDisplay>>>;
export type GetSearchAlertForDisplayLegacyResult = NonNullable<Awaited<ReturnType<typeof getSearchAlertForDisplayLegacy>>>;
export type DeleteSearchAlertPublicResult = NonNullable<Awaited<ReturnType<typeof deleteSearchAlertPublic>>>;
